export default {
   intro: ``,
   footer: '[[ {"a":{"href":"https://hp.euro-tronic.com/#impressum", "title":"Impressum und Datenschutz ansehen", "target":"_blank"}} ]]Impressum / Datenschutz[[ /a ]]',
   approvals: [
      'Ich stimme der Verarbeitung und Speicherung meiner Daten im Rahmen des [[ {"a":{"href":"https://hp.euro-tronic.com/#impressum", "title":"Datenschutz ansehen", "target":"_blank"}} ]]Datenschutzes[[ /a ]] zu.'
   ]
};